export default __webpack_public_path__ + "static/media/Ntorq125Racing_LateralDer.1eba5909.webp";